import React from 'react';

export const Logo = ({ variant = 'default', size = 'full' }) => {
  const isWhite = variant === 'white';
  const textColor = isWhite ? '#ffffff' : '#000000';
  const iconColor = isWhite ? '#ffffff' : '#000000';

  // Size configurations
  const sizeConfig = {
    full: { width: 250, height: 80, iconSize: 25, fontSize: 24, taglineSize: 10, viewBox: "0 0 250 80" },
    medium: { width: 180, height: 60, iconSize: 20, fontSize: 18, taglineSize: 8, viewBox: "0 0 180 60" },
    compact: { width: 80, height: 60, iconSize: 20, fontSize: 0, taglineSize: 0, viewBox: "0 0 80 60" }
  };

  const config = sizeConfig[size] || sizeConfig.full;

  // The emblem is painted with flat colours rather than gradients. The
  // gradients this used to carry had the same colour at every stop, and
  // their ids collided between the two logos on the page — so the white
  // footer logo picked up the black header logo's fill.
  return (
    <svg width={config.width} height={config.height} viewBox={config.viewBox} xmlns="http://www.w3.org/2000/svg">
      {/* Background circle for icon */}
      <circle cx="40" cy="40" r={config.iconSize} fill={iconColor} opacity="0.1"/>

      {/* Data visualization icon - chart bars */}
      <rect x="25" y="35" width="4" height="15" fill={iconColor} rx="2"/>
      <rect x="32" y="25" width="4" height="25" fill={iconColor} rx="2"/>
      <rect x="39" y="30" width="4" height="20" fill={iconColor} rx="2"/>
      <rect x="46" y="20" width="4" height="30" fill={iconColor} rx="2"/>
      <rect x="53" y="28" width="4" height="22" fill={iconColor} rx="2"/>

      {/* Connecting dots/nodes */}
      <circle cx="27" cy="27" r="2" fill={iconColor}/>
      <circle cx="34" cy="17" r="2" fill={iconColor}/>
      <circle cx="41" cy="22" r="2" fill={iconColor}/>
      <circle cx="48" cy="12" r="2" fill={iconColor}/>
      <circle cx="55" cy="20" r="2" fill={iconColor}/>

      {/* Connecting lines */}
      <path d="M 27 27 L 34 17 L 41 22 L 48 12 L 55 20" stroke={iconColor} strokeWidth="1.3" fill="none" opacity="0.6"/>

      {/* Company name - only show for full and medium sizes */}
      {size !== 'compact' && (
        <>
          <text x="80" y="35" fontFamily="-apple-system, BlinkMacSystemFont, 'SF Compact Rounded', 'SF Pro Rounded', system-ui, sans-serif" fontSize={config.fontSize} fontWeight="bold" fill={textColor}>Analytica</text>
          <text x="185" y="35" fontFamily="-apple-system, BlinkMacSystemFont, 'SF Compact Rounded', 'SF Pro Rounded', system-ui, sans-serif" fontSize={config.fontSize + 4} fontWeight="bold" fill={textColor}>X</text>
        </>
      )}

      {/* Tagline - only show for full size */}
      {size === 'full' && (
        <text x="80" y="55" fontFamily="-apple-system, BlinkMacSystemFont, 'SF Compact Rounded', 'SF Pro Rounded', system-ui, sans-serif" fontSize={config.taglineSize} fill={isWhite ? '#d1d5db' : '#000000'} fontWeight="400">Where Data Powers Efficiency</text>
      )}

      {/* Accent elements - only show for full and medium sizes */}
      {size !== 'compact' && (
        <rect x="80" y="40" width="120" height="1" fill={textColor} opacity="0.3"/>
      )}
    </svg>
  );
};

export default Logo;
